<button matButton="filled" (click)="createTenantGroup.emit()">
  {{ 'admin.tenant-groups.create-button' | translate }}
</button>
